import { PbmLoginComponent } from "./pbm-login/pbm-login.component";
import { PbmFuncionalCadastroComponent } from "./pbm-funcional/pbm-funcional-cadastro.component"
import { PbmSevenCadastroComponent } from "./pbm-seven/pbm-seven-cadastro.component";

export const templates = {
    info: {
        tpl: document.querySelector('#template-pbm-info')
    },
    login: {
        tpl: document.querySelector('#template-pbm-login'),
        component: function(){
            return new PbmLoginComponent();
        }
    },
    success: {
        tpl: document.querySelector('#template-pbm-success')
    },
    sevenCadastro: {
      tpl: document.querySelector('#template-pbm-seven-cadastro'),
      component: function (data) {
        return new PbmSevenCadastroComponent(data);
      }
    },
    funcional: {
      tpl: document.querySelector('#template-pbm-funcional'),
      component: function (data) {
        return new PbmFuncionalCadastroComponent(data);
      }
    }
}

export const pbms = [
  {
    id: 45028,
    nome: "SEVEN"
  },
  {
    id: 1334966,
    nome: "FUNCIONAL"
  }
]



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm.constants.js